module.exports = __webpack_public_path__ + "static/media/logoTOP.382629ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoTOP.png
// module id = 983
// module chunks = 0